import type { IntlShape } from 'react-intl'

import { formatInlineList } from 'lib/format/formatList'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'

import type { FeaturedDateRange } from './calendarDayViews'

export function generateStaticMonthCaptions(
  intl: IntlShape,
  featuredDateRanges?: Utils.NonEmptyArray<FeaturedDateRange> | undefined,
  dayPrices?: { [isoDate: string]: App.Property.CalendarDay } | undefined,
): { [isoYearMonth: string]: React.ReactNode } | undefined {
  if (!featuredDateRanges || !dayPrices) return
  const captions = featuredDateRanges.flatMap(({ startIsoDate, endIsoDate, marketedLos, marketedOccupancy }) => {
    if (!marketedLos || !marketedOccupancy) return []
    const occupantsMessage = formatInlineList(formatOccupantsShort(marketedOccupancy).split(', '), 'conjunction', { style: 'long' })
    return [{
      startIsoYearMonth: startIsoDate.slice(0, 7),
      endIsoYearMonth: endIsoDate.slice(0, 7),
      caption: intl.formatMessage({
        id: 'GI3nkPhrdPss2U4Oimnt',
        defaultMessage: 'Prices shown are per-night minimum averages for a {numberOfNights}-night stay with {occupants}. Select dates and click “Apply” to see live prices.',
        description: 'Caption under a calendar month with prices disclaiming that amounts are approximate under specific booking conditions',
      }, {
        numberOfNights: marketedLos,
        occupants: occupantsMessage,
      }),
    }]
  })
  const isoYearMonthsWithPrices = [...new Set(Object.keys(dayPrices).map((isoDate) => isoDate.slice(0, 7)))]
  return Object.fromEntries(isoYearMonthsWithPrices.flatMap((isoYearMonth) => {
    const caption = captions.find(({ startIsoYearMonth, endIsoYearMonth }) => startIsoYearMonth <= isoYearMonth && isoYearMonth <= endIsoYearMonth)
    return caption ? [[isoYearMonth, caption.caption]] : []
  }))
}
